import {AppConfiguration} from "../entity/AppConfiguration";
import {AppConfigurationsState} from "../entity/state/AppConfigurationsState";
import {ProcessStatus} from "../entity/ProcessStatus";

export const initialAppConfigurationsState = {
    configurations: new Array<AppConfiguration>(),
    updateAppConfigurationStatus: ProcessStatus.None,
    appConfigurationsStatus: ProcessStatus.None
} as AppConfigurationsState;